import React, { useState, useEffect } from "react";
import "katex/dist/katex.min.css";
import Latex from "react-latex-next";
import Button from "../../components/common/Button";
import InputBox from "../../components/common/InputBox";
import Div from "../../components/common/Div";
import Text from "../../components/common/Text";
import { Tex } from "react-tex";
import { useHistory } from "react-router-dom";
import {
  tenzero,
  NumberToLetter,
  fixOptions,
  fixMarginQuestionButtons,
  correctColor,
  wrongColor,
  missingColor,
} from "../../constants/Constants";
import Image from "../../components/common/Image";
import QuestionText from "../Partials/QuestionText";
import { Lightbulb } from "@mui/icons-material";
import { Typography } from "@mui/material";
import {formatLatexText} from "../../utils/formatLaTex";

export default function Res_ColumnMatch(props) {
  const [selectedInput, setSelectedInput] = useState(-1);

  const question = props.question;
  const submission = props.submission;
  const questionNumber = props.questionNumber;
  const submissionResults = props.submissionResults;
  const options = props.options[questionNumber];

  const history = useHistory();

  function getButton() {
    if (question.solution.length === 0) return <></>;
    else {
      return (
        <>
          <Button
            backgroundColor={"#FFFFFF"}
            borderRadius={"5px"}
            padding={"5px"}
            width={"220px"}
            marginTop={"10px"}
            margin={"margin: 0 auto"}
            onClick={() => {
              history.push("/solution", {
                solution: question.solution,
                question: props.questionNumber,
              });
            }}
          >
            <Lightbulb></Lightbulb>
          </Button>
        </>
      );
    }
  }

  function MakeBlankArray(i) {
    return Array.apply(null, Array(i)).map(function (x, i) {
      return "";
    });
  }

  function Options() {
    let arr = [];
    for (var i = 0; i < options.length; i++) {
      const letter = NumberToLetter(i);

      const getTex = () => {
        return <Tex texContent={fixOptions("", options[i].text)} />;
      };

      const texCon = options[i].text !== null ? getTex() : <></>;
      let formattedText = formatLatexText(options[i].text);
      const value = (
        <div key={"Text".concat(letter)}>
          <div style={{ display: "flex" }}>
            <div
              style={{
                flex: 3,
                textAlign: "right",
                paddingRight: "0.5em",
                paddingTop: "-9px",
              }}
            >
              <text style={{ fontSize: "0.9rem" }}>{letter.concat(". ")}</text>
            </div>
            <div style={{ flex: 17, textAlign: "left" }}>
              <div style={{ marginTop: "auto", marginBottom: "auto" }}>
                  {formattedText && <Latex>{formattedText}</Latex>}
              </div>
              <Image src={options[i].url} width="150px" />
            </div>
          </div>
        </div>
      );
      arr.push(value);
    }
    return <Div>{arr}</Div>;
  }

  function answerBackToLetter(ansText) {
    return NumberToLetter(options.map((x) => x.text).indexOf(ansText));
  }

  function OptionPlacement() {
    let arr = [];
    for (var i = 0; i < options.length; i++) {
      let formattedText = formatLatexText(options[i].description);
      const value = (
        <Div margin={"0"} key={"Span".concat(i.toString())} display={"flex"}>
          <Div margin={"auto auto auto 35px"} width={"fit-content"}>
              {formattedText && <Latex>{formattedText}</Latex>}
          </Div>
          <Div margin={"auto 35px auto auto"} width={"fit-content"}>
            <InputBox
              width={"25px"}
              height={"20px"}
              textAlign={"center"}
              key={"Input".concat(i.toString())}
              id={"Input".concat(i.toString())}
              // onClick={onClick}
              backgroundColor={
                submission[questionNumber][i] !== ""
                  ? colorGrade(i)
                  : missingColor()
              }
              readOnly
              color="black"
              value={
                submission[questionNumber] === undefined ||
                submission[questionNumber][i] === undefined
                  ? ""
                  : answerBackToLetter(submission[questionNumber][i])
              }
            />
          </Div>
        </Div>
      );
      arr.push(value);
    }

    return (
      <Div display={"flex"} flexDirection={"column"} padding={"10px 0 0 0"}>
        {arr}
        <Div padding={tenzero} />
      </Div>
    );
  }

  function colorGrade(x) {
    if (options[x].text === submission[questionNumber][x])
      return correctColor();
    else return wrongColor();
  }

  return (
    <Div
      backgroundColor={"#FFFFFF"}
      height={"100%"}
      margin={tenzero}
      borderRadius={"5px"}
      padding={"10px"}
    >
      <Div overflowY={"auto"} height={"80%"}>
        <Text margin={tenzero}>
          <Typography
            fontWeight={"bold"}
            color={"#00112e"}
            textAlign={"left"}
            padding={"10px"}
            style={{ fontSize: "1.1rem" }}
          >
            Question {questionNumber + 1}
          </Typography>
          <hr
            style={{
              borderColor: "rgb(0, 17, 46)",
              borderWidth: "1px",
              borderStyle: "solid",
              width: "95%",
            }}
          />
          <QuestionText question={question} />
          <Image
            src={question.url}
            width="250px"
            style={{ display: "block", margin: "0 auto" }}
          />
        </Text>
        {Options()}
        <div
          style={{
            backgroundColor: "#ccc",
            padding: "5px",
            borderRadius: "10px",
            margin: "20px",
          }}
        >
          <div
            style={{
              fontSize: "1rem",
              padding: "10px",
              paddingBottom: "10px",
              borderRadius: "5px",
              fontWeight: "bold",
              textAlign: "left",
              color: "rgb(0, 17, 46)",
              width: "100%",
              margin: "0 auto",
            }}
          >
            Your Answer
          </div>

          {OptionPlacement()}
          {getButton()}
        </div>
      </Div>
    </Div>
  );
}
